"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Shipwell Templating API
 * Allows for customization of documents
 *
 * The version of the OpenAPI document: 0.2.48
 * Contact: engineering@shipwell.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatingApi = exports.TemplatingApiFactory = exports.TemplatingApiFp = exports.TemplatingApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * TemplatingApi - axios parameter creator
 * @export
 */
var TemplatingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingDocumentTypesList: function (limit, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/templating/document-types/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingDocumentTypesRetrieve: function (name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'name' is not null or undefined
                            (0, common_1.assertParamExists)('templatingDocumentTypesRetrieve', 'name', name);
                            localVarPath = "/templating/document-types/{name}/"
                                .replace("{".concat("name", "}"), encodeURIComponent(String(name)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the active template information
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesActiveRetrieve: function (documentType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentType' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesActiveRetrieve', 'documentType', documentType);
                            localVarPath = "/templating/templates/{document_type}/active/"
                                .replace("{".concat("document_type", "}"), encodeURIComponent(String(documentType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {CreateTemplateRequest} [createTemplateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesCreate: function (documentType, createTemplateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentType' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesCreate', 'documentType', documentType);
                            localVarPath = "/templating/templates/{document_type}/"
                                .replace("{".concat("document_type", "}"), encodeURIComponent(String(documentType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createTemplateRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} documentType
         * @param {string} id A unique value identifying this content template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesDestroy: function (documentType, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentType' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesDestroy', 'documentType', documentType);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesDestroy', 'id', id);
                            localVarPath = "/templating/templates/{document_type}/{id}/"
                                .replace("{".concat("document_type", "}"), encodeURIComponent(String(documentType)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} documentType
         * @param {string} [createdAtGt]
         * @param {string} [createdAtGte]
         * @param {string} [createdAtLt]
         * @param {string} [createdAtLte]
         * @param {string} [id]
         * @param {Array<string>} [idIn] Multiple values may be separated by commas.
         * @param {number} [limit] Number of results to return per page.
         * @param {string} [name]
         * @param {string} [nameContains]
         * @param {string} [nameIcontains]
         * @param {string} [nameIexact]
         * @param {Array<string>} [nameIn] Multiple values may be separated by commas.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [updatedAtGt]
         * @param {string} [updatedAtGte]
         * @param {string} [updatedAtLt]
         * @param {string} [updatedAtLte]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesList: function (documentType, createdAtGt, createdAtGte, createdAtLt, createdAtLte, id, idIn, limit, name, nameContains, nameIcontains, nameIexact, nameIn, offset, ordering, search, updatedAtGt, updatedAtGte, updatedAtLt, updatedAtLte, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentType' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesList', 'documentType', documentType);
                            localVarPath = "/templating/templates/{document_type}/"
                                .replace("{".concat("document_type", "}"), encodeURIComponent(String(documentType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (createdAtGt !== undefined) {
                                localVarQueryParameter['created_at__gt'] = (createdAtGt instanceof Date) ?
                                    createdAtGt.toISOString() :
                                    createdAtGt;
                            }
                            if (createdAtGte !== undefined) {
                                localVarQueryParameter['created_at__gte'] = (createdAtGte instanceof Date) ?
                                    createdAtGte.toISOString() :
                                    createdAtGte;
                            }
                            if (createdAtLt !== undefined) {
                                localVarQueryParameter['created_at__lt'] = (createdAtLt instanceof Date) ?
                                    createdAtLt.toISOString() :
                                    createdAtLt;
                            }
                            if (createdAtLte !== undefined) {
                                localVarQueryParameter['created_at__lte'] = (createdAtLte instanceof Date) ?
                                    createdAtLte.toISOString() :
                                    createdAtLte;
                            }
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (idIn) {
                                localVarQueryParameter['id__in'] = idIn.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (nameContains !== undefined) {
                                localVarQueryParameter['name__contains'] = nameContains;
                            }
                            if (nameIcontains !== undefined) {
                                localVarQueryParameter['name__icontains'] = nameIcontains;
                            }
                            if (nameIexact !== undefined) {
                                localVarQueryParameter['name__iexact'] = nameIexact;
                            }
                            if (nameIn) {
                                localVarQueryParameter['name__in'] = nameIn.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (updatedAtGt !== undefined) {
                                localVarQueryParameter['updated_at__gt'] = (updatedAtGt instanceof Date) ?
                                    updatedAtGt.toISOString() :
                                    updatedAtGt;
                            }
                            if (updatedAtGte !== undefined) {
                                localVarQueryParameter['updated_at__gte'] = (updatedAtGte instanceof Date) ?
                                    updatedAtGte.toISOString() :
                                    updatedAtGte;
                            }
                            if (updatedAtLt !== undefined) {
                                localVarQueryParameter['updated_at__lt'] = (updatedAtLt instanceof Date) ?
                                    updatedAtLt.toISOString() :
                                    updatedAtLt;
                            }
                            if (updatedAtLte !== undefined) {
                                localVarQueryParameter['updated_at__lte'] = (updatedAtLte instanceof Date) ?
                                    updatedAtLte.toISOString() :
                                    updatedAtLte;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} documentType
         * @param {string} id A unique value identifying this content template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesMakeDefaultCreate: function (documentType, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentType' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesMakeDefaultCreate', 'documentType', documentType);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesMakeDefaultCreate', 'id', id);
                            localVarPath = "/templating/templates/{document_type}/{id}/make-default/"
                                .replace("{".concat("document_type", "}"), encodeURIComponent(String(documentType)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Take a scenario name and a template configs, and return an HTML or PDF preview using sample data.
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {'pdf'} [format] use the value \&quot;pdf\&quot; for a PDF. Any other value yields HTML
         * @param {PreviewRequest} [previewRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesPreviewCreate: function (documentType, format, previewRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentType' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesPreviewCreate', 'documentType', documentType);
                            localVarPath = "/templating/templates/{document_type}/preview/"
                                .replace("{".concat("document_type", "}"), encodeURIComponent(String(documentType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (format !== undefined) {
                                localVarQueryParameter['format'] = format;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(previewRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {RenderRequest} [renderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesRenderCreate: function (documentType, renderRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentType' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesRenderCreate', 'documentType', documentType);
                            localVarPath = "/templating/templates/{document_type}/render/"
                                .replace("{".concat("document_type", "}"), encodeURIComponent(String(documentType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(renderRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get information on specified template
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesRetrieve: function (documentType, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentType' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesRetrieve', 'documentType', documentType);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesRetrieve', 'id', id);
                            localVarPath = "/templating/templates/{document_type}/{id}/"
                                .replace("{".concat("document_type", "}"), encodeURIComponent(String(documentType)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {string} id A unique value identifying this content template.
         * @param {UpdateTemplateRequest} [updateTemplateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesUpdate: function (documentType, id, updateTemplateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentType' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesUpdate', 'documentType', documentType);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('templatingTemplatesUpdate', 'id', id);
                            localVarPath = "/templating/templates/{document_type}/{id}/"
                                .replace("{".concat("document_type", "}"), encodeURIComponent(String(documentType)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateTemplateRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TemplatingApiAxiosParamCreator = TemplatingApiAxiosParamCreator;
/**
 * TemplatingApi - functional programming interface
 * @export
 */
var TemplatingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TemplatingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingDocumentTypesList: function (limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templatingDocumentTypesList(limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingDocumentTypesRetrieve: function (name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templatingDocumentTypesRetrieve(name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get the active template information
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesActiveRetrieve: function (documentType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templatingTemplatesActiveRetrieve(documentType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {CreateTemplateRequest} [createTemplateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesCreate: function (documentType, createTemplateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templatingTemplatesCreate(documentType, createTemplateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} documentType
         * @param {string} id A unique value identifying this content template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesDestroy: function (documentType, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templatingTemplatesDestroy(documentType, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} documentType
         * @param {string} [createdAtGt]
         * @param {string} [createdAtGte]
         * @param {string} [createdAtLt]
         * @param {string} [createdAtLte]
         * @param {string} [id]
         * @param {Array<string>} [idIn] Multiple values may be separated by commas.
         * @param {number} [limit] Number of results to return per page.
         * @param {string} [name]
         * @param {string} [nameContains]
         * @param {string} [nameIcontains]
         * @param {string} [nameIexact]
         * @param {Array<string>} [nameIn] Multiple values may be separated by commas.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [updatedAtGt]
         * @param {string} [updatedAtGte]
         * @param {string} [updatedAtLt]
         * @param {string} [updatedAtLte]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesList: function (documentType, createdAtGt, createdAtGte, createdAtLt, createdAtLte, id, idIn, limit, name, nameContains, nameIcontains, nameIexact, nameIn, offset, ordering, search, updatedAtGt, updatedAtGte, updatedAtLt, updatedAtLte, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templatingTemplatesList(documentType, createdAtGt, createdAtGte, createdAtLt, createdAtLte, id, idIn, limit, name, nameContains, nameIcontains, nameIexact, nameIn, offset, ordering, search, updatedAtGt, updatedAtGte, updatedAtLt, updatedAtLte, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} documentType
         * @param {string} id A unique value identifying this content template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesMakeDefaultCreate: function (documentType, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templatingTemplatesMakeDefaultCreate(documentType, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Take a scenario name and a template configs, and return an HTML or PDF preview using sample data.
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {'pdf'} [format] use the value \&quot;pdf\&quot; for a PDF. Any other value yields HTML
         * @param {PreviewRequest} [previewRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesPreviewCreate: function (documentType, format, previewRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templatingTemplatesPreviewCreate(documentType, format, previewRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {RenderRequest} [renderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesRenderCreate: function (documentType, renderRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templatingTemplatesRenderCreate(documentType, renderRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get information on specified template
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesRetrieve: function (documentType, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templatingTemplatesRetrieve(documentType, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {string} id A unique value identifying this content template.
         * @param {UpdateTemplateRequest} [updateTemplateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesUpdate: function (documentType, id, updateTemplateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templatingTemplatesUpdate(documentType, id, updateTemplateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TemplatingApiFp = TemplatingApiFp;
/**
 * TemplatingApi - factory interface
 * @export
 */
var TemplatingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TemplatingApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingDocumentTypesList: function (limit, offset, options) {
            return localVarFp.templatingDocumentTypesList(limit, offset, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingDocumentTypesRetrieve: function (name, options) {
            return localVarFp.templatingDocumentTypesRetrieve(name, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the active template information
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesActiveRetrieve: function (documentType, options) {
            return localVarFp.templatingTemplatesActiveRetrieve(documentType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {CreateTemplateRequest} [createTemplateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesCreate: function (documentType, createTemplateRequest, options) {
            return localVarFp.templatingTemplatesCreate(documentType, createTemplateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} documentType
         * @param {string} id A unique value identifying this content template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesDestroy: function (documentType, id, options) {
            return localVarFp.templatingTemplatesDestroy(documentType, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} documentType
         * @param {string} [createdAtGt]
         * @param {string} [createdAtGte]
         * @param {string} [createdAtLt]
         * @param {string} [createdAtLte]
         * @param {string} [id]
         * @param {Array<string>} [idIn] Multiple values may be separated by commas.
         * @param {number} [limit] Number of results to return per page.
         * @param {string} [name]
         * @param {string} [nameContains]
         * @param {string} [nameIcontains]
         * @param {string} [nameIexact]
         * @param {Array<string>} [nameIn] Multiple values may be separated by commas.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [updatedAtGt]
         * @param {string} [updatedAtGte]
         * @param {string} [updatedAtLt]
         * @param {string} [updatedAtLte]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesList: function (documentType, createdAtGt, createdAtGte, createdAtLt, createdAtLte, id, idIn, limit, name, nameContains, nameIcontains, nameIexact, nameIn, offset, ordering, search, updatedAtGt, updatedAtGte, updatedAtLt, updatedAtLte, options) {
            return localVarFp.templatingTemplatesList(documentType, createdAtGt, createdAtGte, createdAtLt, createdAtLte, id, idIn, limit, name, nameContains, nameIcontains, nameIexact, nameIn, offset, ordering, search, updatedAtGt, updatedAtGte, updatedAtLt, updatedAtLte, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} documentType
         * @param {string} id A unique value identifying this content template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesMakeDefaultCreate: function (documentType, id, options) {
            return localVarFp.templatingTemplatesMakeDefaultCreate(documentType, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Take a scenario name and a template configs, and return an HTML or PDF preview using sample data.
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {'pdf'} [format] use the value \&quot;pdf\&quot; for a PDF. Any other value yields HTML
         * @param {PreviewRequest} [previewRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesPreviewCreate: function (documentType, format, previewRequest, options) {
            return localVarFp.templatingTemplatesPreviewCreate(documentType, format, previewRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {RenderRequest} [renderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesRenderCreate: function (documentType, renderRequest, options) {
            return localVarFp.templatingTemplatesRenderCreate(documentType, renderRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get information on specified template
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesRetrieve: function (documentType, id, options) {
            return localVarFp.templatingTemplatesRetrieve(documentType, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
         * @param {string} id A unique value identifying this content template.
         * @param {UpdateTemplateRequest} [updateTemplateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templatingTemplatesUpdate: function (documentType, id, updateTemplateRequest, options) {
            return localVarFp.templatingTemplatesUpdate(documentType, id, updateTemplateRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TemplatingApiFactory = TemplatingApiFactory;
/**
 * TemplatingApi - object-oriented interface
 * @export
 * @class TemplatingApi
 * @extends {BaseAPI}
 */
var TemplatingApi = /** @class */ (function (_super) {
    __extends(TemplatingApi, _super);
    function TemplatingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatingApi
     */
    TemplatingApi.prototype.templatingDocumentTypesList = function (limit, offset, options) {
        var _this = this;
        return (0, exports.TemplatingApiFp)(this.configuration).templatingDocumentTypesList(limit, offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatingApi
     */
    TemplatingApi.prototype.templatingDocumentTypesRetrieve = function (name, options) {
        var _this = this;
        return (0, exports.TemplatingApiFp)(this.configuration).templatingDocumentTypesRetrieve(name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the active template information
     * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatingApi
     */
    TemplatingApi.prototype.templatingTemplatesActiveRetrieve = function (documentType, options) {
        var _this = this;
        return (0, exports.TemplatingApiFp)(this.configuration).templatingTemplatesActiveRetrieve(documentType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
     * @param {CreateTemplateRequest} [createTemplateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatingApi
     */
    TemplatingApi.prototype.templatingTemplatesCreate = function (documentType, createTemplateRequest, options) {
        var _this = this;
        return (0, exports.TemplatingApiFp)(this.configuration).templatingTemplatesCreate(documentType, createTemplateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} documentType
     * @param {string} id A unique value identifying this content template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatingApi
     */
    TemplatingApi.prototype.templatingTemplatesDestroy = function (documentType, id, options) {
        var _this = this;
        return (0, exports.TemplatingApiFp)(this.configuration).templatingTemplatesDestroy(documentType, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} documentType
     * @param {string} [createdAtGt]
     * @param {string} [createdAtGte]
     * @param {string} [createdAtLt]
     * @param {string} [createdAtLte]
     * @param {string} [id]
     * @param {Array<string>} [idIn] Multiple values may be separated by commas.
     * @param {number} [limit] Number of results to return per page.
     * @param {string} [name]
     * @param {string} [nameContains]
     * @param {string} [nameIcontains]
     * @param {string} [nameIexact]
     * @param {Array<string>} [nameIn] Multiple values may be separated by commas.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {string} [updatedAtGt]
     * @param {string} [updatedAtGte]
     * @param {string} [updatedAtLt]
     * @param {string} [updatedAtLte]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatingApi
     */
    TemplatingApi.prototype.templatingTemplatesList = function (documentType, createdAtGt, createdAtGte, createdAtLt, createdAtLte, id, idIn, limit, name, nameContains, nameIcontains, nameIexact, nameIn, offset, ordering, search, updatedAtGt, updatedAtGte, updatedAtLt, updatedAtLte, options) {
        var _this = this;
        return (0, exports.TemplatingApiFp)(this.configuration).templatingTemplatesList(documentType, createdAtGt, createdAtGte, createdAtLt, createdAtLte, id, idIn, limit, name, nameContains, nameIcontains, nameIexact, nameIn, offset, ordering, search, updatedAtGt, updatedAtGte, updatedAtLt, updatedAtLte, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} documentType
     * @param {string} id A unique value identifying this content template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatingApi
     */
    TemplatingApi.prototype.templatingTemplatesMakeDefaultCreate = function (documentType, id, options) {
        var _this = this;
        return (0, exports.TemplatingApiFp)(this.configuration).templatingTemplatesMakeDefaultCreate(documentType, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Take a scenario name and a template configs, and return an HTML or PDF preview using sample data.
     * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
     * @param {'pdf'} [format] use the value \&quot;pdf\&quot; for a PDF. Any other value yields HTML
     * @param {PreviewRequest} [previewRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatingApi
     */
    TemplatingApi.prototype.templatingTemplatesPreviewCreate = function (documentType, format, previewRequest, options) {
        var _this = this;
        return (0, exports.TemplatingApiFp)(this.configuration).templatingTemplatesPreviewCreate(documentType, format, previewRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
     * @param {RenderRequest} [renderRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatingApi
     */
    TemplatingApi.prototype.templatingTemplatesRenderCreate = function (documentType, renderRequest, options) {
        var _this = this;
        return (0, exports.TemplatingApiFp)(this.configuration).templatingTemplatesRenderCreate(documentType, renderRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get information on specified template
     * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatingApi
     */
    TemplatingApi.prototype.templatingTemplatesRetrieve = function (documentType, id, options) {
        var _this = this;
        return (0, exports.TemplatingApiFp)(this.configuration).templatingTemplatesRetrieve(documentType, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {'bill-of-lading' | 'drayage-bill-of-lading' | 'drayage-rate-confirmation' | 'freight-invoice' | 'rate-confirmation' | 'shipping-label'} documentType
     * @param {string} id A unique value identifying this content template.
     * @param {UpdateTemplateRequest} [updateTemplateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatingApi
     */
    TemplatingApi.prototype.templatingTemplatesUpdate = function (documentType, id, updateTemplateRequest, options) {
        var _this = this;
        return (0, exports.TemplatingApiFp)(this.configuration).templatingTemplatesUpdate(documentType, id, updateTemplateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TemplatingApi;
}(base_1.BaseAPI));
exports.TemplatingApi = TemplatingApi;
